import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import {
    Button,
} from '@material-ui/core';

import * as ProgramStore from '../../../app/store/ProgramStore';
import urls from '../../../app/urls';
import { ChoiceNavigationDialog } from '../../../common/components';

const styles = theme => ({
    navActions: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: theme.spacing(8, 0),

        '@media print': {
            display: 'none',
        },
    },
    appActions: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(4, 0),

        '@media print': {
            display: 'none',
        },
    },
    navButton: {
        margin: theme.spacing(0, 6),
    },
    navIconLeft: {
        marginRight: theme.spacing(1),
    },
    navIconRight: {
        marginLeft: theme.spacing(1),
    },
});

class TaskNavigation extends React.Component {
    state = {
        showChoiceNavigateDialog: false,
    };

    goBack = () => {
        window.history.back();
    }

    clickNext = nextDirection => () => {
        const { task, taskContentRef, readOnly } = this.props;
        const { currentTaskNr, elementIndex, elementGroup } = task;
        const isTaskInModule = !!task.module;

        const nextTaskNr = currentTaskNr + nextDirection;
        const isLastTask = nextTaskNr > task.listLength - 1;
        const isFirstTask = nextTaskNr < 0;
        const next = isTaskInModule ? `${elementIndex}/${nextTaskNr}` : `${nextTaskNr}`;

        let redirect = '';
        if (task.redirectHomeAfterLastTask && isLastTask) {
            redirect = urls.inside.home;
        } else if (task.saveAndAbortNavigation && (!isTaskInModule || (isFirstTask || isLastTask))) {
            redirect = urls.inside.home;
        } else if (isFirstTask || isLastTask) {
            if (isTaskInModule) {
                redirect = urls.inside.home;
            } else {
                redirect = `${urls.inside.program}/${elementGroup}`;
            }
        } else {
            redirect = `${urls.inside.program}/${elementGroup}/${next}`;
        }

        const lastTaskCallback = () => {
            const incompleteTaskIndex = task.module ? task.module.tasks.findIndex(d => !d.completed) : -1;
            if (incompleteTaskIndex > -1) {
                this.setState({ showChoiceNavigateDialog: true, incompleteTaskIndex });
            } else {
                this.props.redirect(urls.inside.home);
            }
        };

        const go = () => {
            if (isLastTask && task.showPopupAfterLastTask) {
                lastTaskCallback();
            } else {
                this.props.redirect(redirect);
            }
        };

        if (taskContentRef.current) {
            if (readOnly) {
                this.props.redirect(redirect);
            } else if (nextDirection > 0) {
                taskContentRef.current.validateAndSave(go, task.isSubmitTask);
            } else {
                taskContentRef.current.saveWithoutValidation(go);
            }
        }
    }

    cancelNavigate = () => {
        this.setState({ showChoiceNavigateDialog: false });
    }

    render() {
        const {
            classes, translate, task,
        } = this.props;

        const { elementIndex, elementGroup } = task;

        const isTaskInModule = !!task.module;
        const isLastTask = task.currentTaskNr === task.listLength - 1;
        const isFirstTask = task.currentTaskNr === 0;
        const prevText = task.saveAndAbortNavigation && (isFirstTask || !isTaskInModule) ? 'cancel' : 'task.goBack';
        const nextText = task.saveAndAbortNavigation && (isLastTask || !isTaskInModule) ? 'send'
            : isLastTask ? 'task.goToHomePage' : 'task.goForward';

        const hideCompleteButton = isLastTask && !task.saveAndAbortNavigation && !task.showCompleteNavigation;

        return (
            <>
                {(task.saveAndAbortNavigation || task.showNextPrevNavigation) && (
                    <div className={classes.navActions}>
                        <Button
                            variant="outlined"
                            color="secondary"
                            style={{ visibility: task.hidePrevNavigationIfFirstTask && isFirstTask ? 'hidden' : 'visible' }}
                            onClick={this.clickNext(-1)}
                        >
                            {translate(prevText)}
                        </Button>
                        {!hideCompleteButton && (
                            <Button
                                color="secondary"
                                variant="contained"
                                onClick={this.clickNext(1)}
                            >
                                {translate(nextText)}
                            </Button>
                        )}
                    </div>
                )}

                <div className={classes.appActions}>
                    {task.showBackNavigation && (
                        <Button
                            onClick={this.goBack}
                            className={classes.navButton}
                        >
                            {translate('task.goBack')}
                        </Button>
                    )}
                    {task.showHomeNavigation && !task.saveAndAbortNavigation && (
                        <Button
                            component={Link}
                            to={urls.inside.home}
                            className={classes.navButton}
                        >
                            {translate('task.goToHomePage')}
                        </Button>
                    )}
                </div>


                <ChoiceNavigationDialog
                    open={this.state.showChoiceNavigateDialog}
                    onCancel={this.cancelNavigate}
                    title={translate('task.moduleIncompletedHeader')}
                    description={translate('task.moduleIncompletedDescription')}
                    primaryText={translate('task.goToLastUnfinished')}
                    primaryLink={`${urls.inside.program}/${elementGroup}/${elementIndex}/${this.state.incompleteTaskIndex}`}
                    secondaryText={translate('task.goToOverview')}
                    secondaryLink={urls.inside.home}
                />
            </>
        );
    }
}

TaskNavigation.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    task: PropTypes.object.isRequired,
    redirect: PropTypes.func.isRequired,
    taskContentRef: PropTypes.object.isRequired,
    readOnly: PropTypes.bool,
};

TaskNavigation.defaultProps = {
    readOnly: false,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

const mapDispatchToProps = dispatch => ({
    redirect: bindActionCreators(ProgramStore.actionCreators, dispatch).redirect,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TaskNavigation));
